import React, { useState } from "react";
import {
    STEP_ARENA_AGE_GROUPS,
    STEP_ARENA_INDIVIDUAL_SECTIONS,
} from "./StepArenaPlans";
import { StepArenaPlanCard } from "./StepArenaPlanCard";

// Mirror of stepsc-admin's StepArenaIndividualSection.

export const StepArenaIndividualSection = ({ formData, setFormData }) => {
    const [ageGroup, setAgeGroup] = useState('adult');

    const visibleSections = STEP_ARENA_INDIVIDUAL_SECTIONS.filter(
        (s) => s.ageGroup === ageGroup
    );

    const handleAgeChange = (group) => {
        if (group === ageGroup) return;
        setAgeGroup(group);
        setFormData((prev) => ({
            ...prev,
            type: 'Individual',
            time: 0,
            totalAmount: 0,
            payableAmount: 0,
            discount: 0,
            entries: '',
            totalEntries: '',
            remainingEntries: '',
            premium: false,
            description: '',
            days: [],
            tempDays: [],
            selectedPlanId: null,
        }));
    };

    return (
        <div className="flex flex-col gap-6">
            <div className="flex flex-col gap-2">
                <label className="text-sm text-gray-600">Mosha:</label>
                <div className="inline-flex p-1 bg-gray-100 rounded-lg w-fit">
                    {STEP_ARENA_AGE_GROUPS.map((g) => {
                        const active = ageGroup === g.key;
                        return (
                            <button
                                key={g.key}
                                type="button"
                                onClick={() => handleAgeChange(g.key)}
                                className={`px-4 py-1.5 rounded-md text-sm font-semibold transition-all
                                    ${active
                                        ? 'bg-[#003DFE] text-white shadow'
                                        : 'text-gray-700 hover:bg-white'}
                                `}
                            >
                                {g.label}
                            </button>
                        );
                    })}
                </div>
            </div>

            <div className="flex flex-col gap-6">
                {visibleSections.map((section) => (
                    <div key={section.key} className="flex flex-col gap-3">
                        <div>
                            <h2 className="text-2xl font-bold">{section.title}</h2>
                            {section.subtitle && (
                                <p className="text-sm text-gray-600">{section.subtitle}</p>
                            )}
                        </div>
                        <StepArenaPlanCard
                            section={section}
                            formData={formData}
                            setFormData={setFormData}
                        />
                    </div>
                ))}
            </div>
        </div>
    );
};

export default StepArenaIndividualSection;
